















import { defineComponent, PropType } from '@vue/composition-api';
import AppText from '@berlin-front/common/components/elements/AppText';
import { formatNumber, formatMonth } from '@berlin-front/common/utils';
import useCss from '@berlin-front/common/composables/useCss';

// 各月の支払い
type SplitAmount = {
  // 請求月
  billingMonth: string;
  // 金額
  amount: number;
};

export default defineComponent({
  name: 'PaymentTimeLine',
  components: {
    AppText,
  },

  props: {
    amounts: {
      type: Array as PropType<SplitAmount[]>,
      required: true,
    },
  },

  setup(props) {
    useCss(
      () => `
        .PaymentTimeLine__TimeLine::after {
          grid-row: 1 / span ${props.amounts.length};
        }
      `,
    );
    return { formatNumber, formatMonth };
  },
});
